import { useState, type ReactNode } from "react";
import type { Profile, PublicEventsView, WorldSnapshot } from "@frontier/protocol/contracts";
import type { ContractHistoryControls } from "./use-contract-history";
import { ContractHistoryPanel } from "./ContractHistoryPanel";
import { PublicEventPanel } from "./PublicEventPanel";
import { AchievementPanel } from "./AchievementPanel";
import type { AchievementControls } from "./use-achievements";
import "./station-activities.css";

export function StationActivities({ children, profile, world, events, connected, onJoinEvent, history, historyContent, latestRunId, achievements }: {
  children: ReactNode;
  profile: Profile;
  world: WorldSnapshot;
  events: PublicEventsView;
  connected: boolean;
  onJoinEvent: (id: string) => void;
  history?: ContractHistoryControls;
  historyContent?: ReactNode;
  latestRunId?: string | undefined;
  achievements?: AchievementControls;
}) {
  const [view, setView] = useState<"quests" | "events" | "achievements" | "history">("quests");
  const training = profile.tutorial !== null && !profile.tutorial.docked;
  return (
    <div className="station-activities">
      {!training && <nav className="station-activity-tabs" aria-label="Занятия на станции">
        <button aria-pressed={view === "quests"} onClick={() => setView("quests")}>ЗАДАНИЯ</button>
        <button aria-pressed={view === "events"} onClick={() => setView("events")}>СОБЫТИЯ</button>
        {achievements && <button aria-pressed={view === "achievements"} onClick={() => setView("achievements")}>ДОСТИЖЕНИЯ</button>}
        {history && <button aria-pressed={view === "history"} onClick={() => setView("history")}>ИСТОРИЯ</button>}
      </nav>}
      <div className="station-view" hidden={!training && view !== "quests"}>{children}</div>
      {!training && <>
        <div className="station-view" hidden={view !== "events"}><PublicEventPanel embedded world={world} view={events} profile={profile} connected={connected} onJoin={onJoinEvent} /></div>
        {achievements && <div className="station-view" hidden={view !== "achievements"}><AchievementPanel {...achievements} active={view === "achievements"} /></div>}
        {history && <div className="station-view" hidden={view !== "history"}><ContractHistoryPanel {...history} latest={historyContent} latestRunId={latestRunId} active={view === "history"} /></div>}
      </>}
    </div>
  );
}
